import { Autocomplete, Box, InputAdornment, OutlinedInput, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import useApiRequest from '../services/apiRequest';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import AssistedSearch from './AssistedSearch';
import { AccountCircle, Add } from '@mui/icons-material';


function SearchInput() {
    const { queryStringConverter } = useApiRequest();
    const { typedDescription, setTypedDescription } = useContext(GlobalStateContext);
    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);

    const { searchTerm, setSearchTerm } = useContext(GlobalStateContext);

    const { data, error, loading } = useFetch(endpoints.AUTOCOMPLETE, queryStringConverter({ desc: typedDescription == "" ? " " : typedDescription }));

    const [open, setOpen] = useState(false);

    const options = () => {
        if (data) {
            return data.map((d: any) => d.desc)
        } else {
            return [];
        }
    }

    useEffect(() => {
        if (typedDescription == "") {
            setOpen(true);
        }
    }, [typedSearchType])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm != "") {
                setTypedDescription(searchTerm);
            }
        }, 1500)

        return () => clearTimeout(delayDebounceFn)
    }, [searchTerm])

    return (typedSearchType == "smart" ? <>
        <Autocomplete
            options={options()}
            onInputChange={(event, newInputValue) => {
                setSearchTerm(newInputValue);
            }}

            value={searchTerm}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onChange={(ev) => setSearchTerm(ev.target.value)}
                    label="Digite uma descrição"
                    required
                    InputProps={{
                        ...params.InputProps,
                        type: 'text',
                    }}
                />)}
        /></> : <>
        <AssistedSearch open={open} onClose={() => setOpen(false)} />
        <Box sx={{
            boxShadow: 3,
            "&:hover": {
                boxShadow: 8,
            },
        }}>
            <OutlinedInput
                value={typedDescription}
                required
                placeholder='Clique para adicionar'
                endAdornment={<InputAdornment position="end"><Add /></InputAdornment>}
                sx={{ cursor: 'pointer' }}
                fullWidth
                onClick={() => setOpen(true)}
            /></Box>


    </>);
}

export default SearchInput;
